<template>
  <div class="Add_scale">

    <el-form ref="form" label-width="80px" style="padding-top: 20px;margin-left: 20px;">

      <el-form-item label="量表名称">
        <el-input placeholder="量表名称" v-model="papername" :disabled="true">
          <template slot="append" > <span style="cursor: pointer;" @click="cel()">选择量表</span></template>
        </el-input>
      </el-form-item>

      <el-form-item label="因子名称">
        <el-select v-model="factorID" placeholder="请选择因子名称" @change="getinfo()">
          <el-option v-for="(item,i) in options" :key="i" :label="item.factorName" :value="item.factorID">
          </el-option>
        </el-select>
      </el-form-item>





      <el-form-item  label="题目名称">
        <el-select v-model="questionID" placeholder="请选择因子名称">
          <el-option v-for="(item,i) in options2" :key="i" :label="item.questionName" :value="item.questionID">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="计分规则">
        <el-radio-group v-model="scoreType">
          <el-radio label="0">正向计分</el-radio>
          <el-radio label="1">反向计分</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item>
        <el-button  type="primary" @click="onSubmit(2)">确定1</el-button>
      </el-form-item>

    </el-form>

    <el-dialog class="cscs" :visible.sync="dialogVisible" width="600px" style="height: 700px;" >
      <scales_Pop @sendmsg="getmsg"></scales_Pop>
    </el-dialog>

  </div>
</template>
<script>
import scales_Pop from '@/components/scales_Pop.vue'
  export default {
    data() {
      return {
        papername:'',
        papernameid:'',
        scoreType:'',
        factorID:'',
        questionID:'',
        dialogVisible:false,
        options:[],
        options2:[],
        factorName:'',
        pd:true,
      };
    },
    components:{
      scales_Pop
    },
    methods: {
      onSubmit(type) {
        if(type == 1){
          this.$Http_Post('/paperconfig/factorquestion/edit', {
            factorID:this.factorID,
            questionID:this.questionID,
            scoreType:this.scoreType,
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
            }else{
              this.Global.request_failure(res.Message);
            }
          });
        }else{
          this.$Http_Post('/paperconfig/factorquestion/add', {
            factorID:this.factorID,
            questionID:this.questionID,
            scoreType:this.scoreType,
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
            }else{
              this.Global.request_failure(res.Message);
            }
          });
        }
      },
      getinfo(){//根据因子获取数据
        this.$Http_Post('paperconfig/factorquestion/list', {factorID:this.factorID}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.options2 = res.Data;
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      },
      cel(){
        this.dialogVisible = true;
      },
      getmsg(val){//量表点击时子组件传过来值
        this.yz = [];
        this.papername = val.label;
        this.paperCode = val.val;
        this.$Http_Post('paperconfig/factor/list', {paperCode:val.val}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.options = [];
            this.factorID = '';
            this.options = res.Data;

            if(res.Data.length > 0){
              this.pd = true;
            }else{
              this.pd = false;
            }
          }else{
            this.Global.request_failure(res.Message);
          }
        });
      },
    },
    mounted(){
      
    }
  };
</script>
<style>
.Add_scale{width: 100%;height: 100%;background-color: #fff;overflow: auto;}
.Add_scale .el-input{width: 300px;}
.Add_scale .el-textarea{width: 500px;}
.Add_scale .el-form-item__label{width: 100px !important;text-align: right;}
.Add_scale .el-form-item__content{margin-left: 100px !important;}














.avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
.avatar {width: 215px;height: 148px;display: block;}
.cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 150px;}
.avatar-uploader {position: absolute;top: 0px;left: 70px;}
.cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 297px;width: 350px;}
.scale {margin-top: 30px;}
</style>